import type { IndustryContributor } from '@/Api/studioServerTypes';

export function buildIndustryContributorPayload(
  industryContributor: IndustryContributor,
  industryContributorEdited: Partial<IndustryContributor>,
): IndustryContributor {
  return {
    IndustryContributorIdentifier: industryContributor.IndustryContributorIdentifier,
    AccountNumber: industryContributor.AccountNumber,
    ExternalContributorId: industryContributor.ExternalContributorId,
    Name: industryContributor.Name,
    AddedBy: industryContributor.AddedBy,
    DateAdded: industryContributor.DateAdded,
    ModifiedBy: industryContributor.ModifiedBy,
    DateModified: industryContributor.DateModified,
    IsSterling: industryContributor.IsSterling,
    ContactIdentifier: industryContributorEdited.ContactIdentifier ?? industryContributor.ContactIdentifier,
    AssignedResourceIdentifier: industryContributorEdited.AssignedResourceIdentifier ?? industryContributor.AssignedResourceIdentifier,
  };
}
